import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const CameraResolution = ({ onCameraResolutionSelected }) => {
  const [selectedCameraResolution, setSelectedCameraResolution] =
    useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.cameraresolution) {
        const cameraResolutionObject = firstResult.cameraresolution;
        if (cameraResolutionObject.trim() !== "") {
          setVariations(cameraResolutionObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleCameraResolutionClick = (cameraresolution) => {
    setSelectedCameraResolution(cameraresolution);
    onCameraResolutionSelected(cameraresolution);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Camera Resolution:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedCameraResolution === variation ? "selected" : ""}`}
            onClick={() => handleCameraResolutionClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default CameraResolution;
